// 返回成功
export const SUCCESS = ['1', 1]
// 返回失败
export const ERROR = ['0', 0]
// 需要登录
export const NEED_LOGIN = ['1004', 1004, '907', 907]

// 默认返回success
export default SUCCESS